import {
    DOCK_TYPE_LIST_GET,
    DOCK_TYPE_LIST_GET_F,
    DOCK_TYPE_LIST_GET_R,
    DOCK_TYPE_SELECTED_SET
} from '../actionType'

const initialState = {
    dock_types: [],
    isLoading: false,
    error: null,
    totalPage: 0,
    totalElement: 0,
    selectedDockType: null,
}

export default function dockTypeReducer (state = initialState, action : any)  {
    switch (action.type) {
        case DOCK_TYPE_LIST_GET:
            return {
            ...state,
            isLoading: true,
            error: null
            }
        case DOCK_TYPE_LIST_GET_F:
            // console.log('action called')
            // console.log(action.payload.content,'content')
            return {
                ...state,
                isLoading: false,
                dock_types: action.payload.content,
                totalPage: action.payload.total_page,
                totalElement: action.payload.total_element
            }
        case DOCK_TYPE_LIST_GET_R:
            
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        case DOCK_TYPE_SELECTED_SET:
            return {
                ...state,
                selectedDockType: action.payload
            }
        default:
            return state
    }
}